module.exports = __webpack_public_path__ + "namibia.svg?8d58ac6b37c500646834b6b86ea892fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/namibia.svg
// module id = 241
// module chunks = 10